import React, { useRef, useCallback, useEffect } from 'react';
import Popup from 'reactjs-popup';
import PropTypes from 'prop-types';
import 'src/utils/popup.scss';

Modal.propTypes = {
  children: PropTypes.any.isRequired,
  trigger: PropTypes.node,
  onClose: PropTypes.func,
  onOpen: PropTypes.func,
  nested: PropTypes.bool,
  closeOnDocumentClick: PropTypes.bool,
  isOpen: PropTypes.bool,
  lockScroll: PropTypes.bool
};

export default function Modal({
  children,
  trigger,
  onClose,
  onOpen,
  nested,
  closeOnDocumentClick,
  isOpen,
  lockScroll = true
}) {
  const ref = useRef();
  if (isOpen) {
    handleOpen();
  }

  function handleClose() {
    const scrollArrow = document.getElementById('scroll-arrow');
    if (scrollArrow) {
      scrollArrow.style.display = 'flex';
    }
    onClose?.();
    document.body.style.overflow = 'unset';
  }

  function handleOpen() {
    const scrollArrow = document.getElementById('scroll-arrow');
    if (scrollArrow) {
      scrollArrow.style.display = 'none';
    }
    onOpen?.();
  }

  const handleEvent = useCallback((close) => {
    close?.();
  }, []);

  useEffect(() => {
    window.addEventListener('popstate', () => handleEvent(ref.current?.close));
    return () => window.removeEventListener('popstate', handleEvent);
  }, [handleEvent]);

  return (
    <Popup
      ref={ref}
      modal
      lockScroll={lockScroll}
      open={isOpen}
      closeOnDocumentClick={closeOnDocumentClick}
      trigger={trigger}
      onClose={handleClose}
      onOpen={handleOpen}
      overlayStyle={{ overflowY: 'auto', zIndex: '1001' }}
      nested={nested}>
      {children}
    </Popup>
  );
}
